import { useEffect, useMemo, useState } from "react";

export function useIsDesktop(): boolean {
  const media = useMemo(() => window.matchMedia("(min-width: 1024px)"), []);
  const [matches, setMatches] = useState(() => media.matches);

  useEffect(() => {
    function listener() {
      setMatches(media.matches);
    }

    media.addEventListener("change", listener);

    return () => {
      media.removeEventListener("change", listener);
    };
  }, [media]);

  return matches;
}
